import { usePageParams } from 'hooks/use-page-params';
import { useQuery } from 'react-query';
import http from '../config/http-service';

export interface ICrmDedDetailLicense {
  id: number;
  licenseNumber: string;
  licenseStatus: string;
  legalType: string;
  expiryDate: string;
  activities: string;
  isExpiringSoon: boolean;
  contactInfo: {
    telephone?: string;
    mobile?: string;
    fax?: string;
    email?: string;
  };
  location: {
    address?: string;
    area?: string;
    subArea?: string;
    community?: string;
    landmark?: string;
    parcelId?: string;
    street?: string;
    building?: string;
    floor?: string;
    unit?: string;
    gpsCoordinates?: string;
  };
  pageUrl?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICrmDedDetailBusiness {
  businessId: string;
  businessName: string;
  englishName?: string;
  arabicName?: string;
  primaryContact?: {
    mobile?: string;
    telephone?: string;
    fax?: string;
    email?: string;
  };
  primaryLocation?: {
    area?: string;
    subArea?: string;
    community?: string;
    address?: string;
    landmark?: string;
    parcelId?: string;
    street?: string;
    building?: string;
    floor?: string;
    unit?: string;
    gpsCoordinates?: string;
  };
  summary?: {
    totalLicenses: number;
    licenseStats: Record<string, number>;
    hasActiveLicense: boolean;
    expiringSoonCount: number;
    latestUpdate: string;
  };
  licenses: ICrmDedDetailLicense[];
}

export interface ICrmDedDetailsApiResponse {
  data: ICrmDedDetailBusiness[];
  total: number;
  pageCount: number;
  page: number;
  limit: number;
}

export const getCrmDedDetailsEndpointIdentifier = 'crm-ded-details';

export const useGetCrmDedDetailsApi = (options: { onError?: (error: any) => void } = {}) => {
  const { getPageParams } = usePageParams();
  const params = getPageParams();

  const queryKey = [getCrmDedDetailsEndpointIdentifier, params.page, params.limit, params.businessName];

  return useQuery({
    queryKey,
    queryFn: async (): Promise<ICrmDedDetailsApiResponse> => {
      console.log('🔍 DED Details API Call - Params:', {
        page: params.page || 1,
        limit: params.limit || 20,
        businessName: params.businessName || undefined,
      });

      const { data } = await http.get('ums/v1/crm/management/ded/licenses', {
        params: {
          page: params.page || 1,
          limit: params.limit || 20,
          businessName: params.businessName || undefined,
        },
      });

      console.log('✅ DED Details API Response:', data);
      return data;
    },
    onError: options.onError,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};
